// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { newsListViewStyles } from "@tps/Overrides/Widgets/NewsList/NewsListView";
import { ellipsis, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

newsListViewStyles.listGridContainer = {
    gap: 20,
};

newsListViewStyles.newsGridItem = {
    width: [12, 12, 6, 4, 4],
};

newsListViewStyles.newsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        border: 1px solid ${getColor("common.ui3")};
    `,
};

newsListViewStyles.imageWrapper = {
    css: css`
        width: 100%;
        height: 132px;
        margin-bottom: 16px;

        ${xScreen("lte", "md")} {
            height: 110px;
        }

        ${xScreen("lte", "xs")} {
            height: 101px;
        }
    `,
};

newsListViewStyles.image = {
    css: css`
        &, img {
            width: 100%;
            height: 100%;
            max-height: 100%;
            object-fit: cover;
            box-shadow: 0 2px 0 0 ${getColor("primary")};
        }
    `,
};

newsListViewStyles.titleLink = {
    typographyProps: {
        size: 20,
        lineHeight: "28px",
        color: "text.main",
        weight: 700,
    },
    css: css`
        margin: 6px 0 12px;
        padding: 0 17px;
    `,
};

newsListViewStyles.summaryText = {
    size: 14,
    lineHeight: "22px",
    weight: "normal",
    color: "text.main",
    css: css`
        margin-bottom: 20px;
        padding: 0 17px;
        ${ellipsis(7)}
    `,
};

newsListViewStyles.dateAndAuthorWrapper = {
    css: css`
        margin-right: 5px;
    `,
};

newsListViewStyles.authorText = {
    size: 14,
    weight: "bold",
    css: css`
        margin-right: 8px;
    `,
};

newsListViewStyles.seperator = {
    css: css`
        &:after {
            content: "-";
            margin-right: 8px;
        }
    `,
};

newsListViewStyles.publishDateText = {
    size: 14,
    italic: true,
    color: "secondary",
};

newsListViewStyles.buttonContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: auto;
        padding: 0 17px 17px 17px;
    `,
};

newsListViewStyles.readMoreButton = {
    variant: "primary",
    css: css`
        flex: 0 0 118px;
    `,
};

newsListViewStyles.paginationGridItem = {
    width: 12,
    css: css`
        display: block;
    `,
};
